export {
    setPageTitle
};

async function setPageTitle(title: string) {
    document.title = (title ? title + " - " : "") + "Boostlingo AI Pro";
}